import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let types = useDataValue({
    context: 'retail_item_types',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'retail_item',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      if (value) {
        let type = types.find(item => item.id === value)

        next.type_id = type.id
        next.amount = type.price
      } else {
        next.type_id = null
        next.amount = 0
      }
    })
  }
}
